<template>
  <div class="file-container">
    <div v-if="fileUrl === 0">加载中...</div>
    <div v-else-if="fileUrl === -1">没有找到该文件</div>
    <img v-else-if="fileType === 'image'" :src="fileUrl" />
    <video
      v-else-if="fileType === 'video'"
      :src="fileUrl"
      ref="videoElement"
      controls
    ></video>
    <Suspense v-else-if="fileType === 'markdown'">
      <template #default>
        <component
          :is="MarkdownView"
          :markdown-path="fileUrl"
          :page-title="easyFile.name"
        />
      </template>
      <template #fallback>
        <div>加载中...</div>
      </template>
    </Suspense>
    <iframe v-else class="iframe" :src="fileUrl" frameborder="0"></iframe>

    <div class="home-button" @click="goToHome">EasyLink.cc</div>
  </div>
</template>

<script setup>
import { ref, shallowRef, defineAsyncComponent, watchEffect } from "vue";
import { useRouter } from "vue-router";
import Tracking from "@/model/tracking.js";

const router = useRouter();
const videoElement = ref(null);
const MarkdownView = shallowRef(null);

// 只在需要时才加载 MarkdownView 组件
const loadMarkdownView = async () => {
  console.log("loadMarkdownView", props.fileType);
  if (props.fileType === "markdown" && !MarkdownView.value) {
    MarkdownView.value = defineAsyncComponent(() =>
      import("./MarkdownView.vue")
    );
  }
};

const props = defineProps({
  fileUrl: {
    type: [Number, String],
    required: true,
  },
  fileType: {
    type: String,
    required: true,
  },
  easyFile: {
    type: Object,
    required: true,
  },
});

// 监听 fileType 变化，按需加载 MarkdownView
watchEffect(() => {
  loadMarkdownView();
});

const goToHome = () => {
  Tracking.send({
    trigger: "button-click",
    page: "file-view",
    object: "home-button",
  });
  router.push("/");
};
</script>

<style scoped lang="scss">
.file-container {
  height: 100%;
  width: 100%;
  color: white;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.home-button {
  position: fixed;
  top: px2rem(30);
  right: px2rem(30);
  transform: none;
  padding: px2rem(8) px2rem(16);
  border: px2rem(1) solid rgba(255, 255, 255, 0.18);
  border-radius: px2rem(6);
  font-family: "LingWai SC Medium";
  font-size: px2rem(13);
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(px2rem(8));
  z-index: 100;
  display: flex;
  align-items: center;
  gap: px2rem(4);

  &::before {
    content: "powered by";
    font-family: "思源黑体 Light";
    font-size: px2rem(11);
    opacity: 0.6;
    font-weight: 300;
  }

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    color: rgba(255, 255, 255, 0.6);
    transform: translateY(-1px);
    box-shadow: 0 px2rem(2) px2rem(8) rgba(0, 0, 0, 0.1);
    color: rgba(255, 255, 255, 0.8);

    &::before {
      opacity: 0.6;
    }
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 768px) {
    top: px2rem(16);
    right: px2rem(16);

    &::before {
      display: none;
    }
  }
}

.iframe {
  height: 100%;
  width: 100%;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

video {
  width: 100%;
  height: 100%;
}
</style>
